module.exports = __webpack_public_path__ + "img/empty@2x.b0ded74d.png";